import Vue from 'vue';
import newsletter from './newsletter';

const listingApp = (app = '#listing', listing = '#entries') => {
	if (!document.querySelector(app)) return;

	new Vue({
		el: app,
		data: {
			isLoading: false,
			hasNextPage: true
		},
		delimiters: ['${', '}'],
		mixins: [newsletter],
		methods: {
			loadMore(e) {
				const btn = e.target;
				const url = new URL(btn.href);
				const entries = document.querySelector(listing);

				this.isLoading = true;

				const request = new Request(url.href, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					}
				});

				fetch(request).then(response => response.json()).then(json => {
					const html = json.html;
					const hasNextPage = json.hasNextPage;

					entries.innerHTML += html;
					url.searchParams.set('page', parseInt(url.searchParams.get('page')) + 1);
					btn.href = url.href;

					this.isLoading = false;
					this.hasNextPage = hasNextPage;
				}).catch(error => {
					console.error(error);
				});
			}
		}
	});
};

export default listingApp;


// WEBPACK FOOTER //
// ./assets/js/partials/listing.js